import axios from './index';

class VariantChargesApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.id) {
      query += `saving_plan_variant_id=${data.id}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.booleanFilter) {
      query += `is_active=${data.booleanFilter}&`;
    }
    if (data.selectedValues) {
      query += `category=${data.selectedValues}&`;
    }
    if (data.selectedPeriod) {
      query += `period=${data.selectedPeriod}&`;
    }

    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    console.log(data);
    let request = {
      saving_plan_variant_id: data.variantId,
      base_amount: Number(data.base_amount),
      total_amount: Number(data.total_amount),
      gst: Number(data.gst),
      name: data.name,
      type: data.type,
    };
    console.log('Data for Create', request);
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.name) request.name = data.name;
    if (data.saving_plan_variant_id)
      request.saving_plan_variant_id = data.variantId;
    if (data.base_amount) request.base_amount = Number(data.base_amount);
    if (data.total_amount) request.total_amount = Number(data.total_amount);
    if (data.gst) request.gst = Number(data.gst);
    if (data.type) request.type = data.type;
    console.log('data :: ', data, request);
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };

  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };
}

let base = 'dashboard/saving-plan-variant-charges';

export default VariantChargesApi;
